<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      class="stroke"
      x="4"
      y="4"
      width="16"
      height="16"
      rx="3.5"
      stroke="none"
      stroke-width="1.2"
    />
    <path class="stroke" d="M4 8.5H20" stroke="none" stroke-width="1.2" />
    <path
      class="stroke"
      d="M8 17V13.75"
      stroke="none"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      class="stroke"
      d="M12 17V11.25"
      stroke="none"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      class="stroke"
      d="M16 17V12.5"
      stroke="none"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script lang="ts">
// Drawn on the same 24px grid and 1.2 stroke weight as the other settings
// icons, with the ~16px content footprint most of them use (e.g. the lock's
// 4→20 body): they are all rendered at the same CSS size, so a smaller
// viewBox or a full-bleed drawing reads bigger and bolder than its neighbors.
import { defineComponent } from "vue";

export default defineComponent({
  name: "DashboardIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
